import {connect} from 'react-redux';
import Link from './Link';

export default connect(() => ({}), {})(Link);
